import { render, staticRenderFns } from "./XFolderTree.vue?vue&type=template&id=f98aa1e8&"
import script from "./XFolderTree.vue?vue&type=script&lang=js&"
export * from "./XFolderTree.vue?vue&type=script&lang=js&"
import style0 from "./XFolderTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports